module.exports = __webpack_public_path__ + "img/fast-truck-solid-blue.b6d5baf0.svg";